import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Box, Button, MenuItem } from '@mui/material';
import { ObjectModel } from '../items/hooks/HObjects';

interface ObjectQuickFormProps {
    open: boolean;
    onClose: () => void;
    formData: Partial<ObjectModel>;
    setFormData: React.Dispatch<React.SetStateAction<Partial<ObjectModel>>>;
    assetClassOptions: readonly string[];
    onSubmit: () => void;
}

const ObjectQuickForm: React.FC<ObjectQuickFormProps> = ({
    open,
    onClose,
    formData,
    setFormData,
    assetClassOptions,
    onSubmit,
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
            <DialogTitle>Add New Object</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: 1 }}>
                    <TextField
                        fullWidth
                        label='Object Name'
                        value={formData.name || ''}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        required
                        autoFocus
                    />
                    <TextField
                        fullWidth
                        select
                        label='Asset Class'
                        value={formData.assetclass || assetClassOptions[0] || ''}
                        onChange={(e) => setFormData({ ...formData, assetclass: e.target.value })}
                        required
                    >
                        {assetClassOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        fullWidth
                        label='Description'
                        value={formData.description || ''}
                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                        multiline
                        rows={3}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onSubmit} variant='contained' color='primary'>
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ObjectQuickForm;
